import dio, { DioContext, DioType } from './init';

/**
 * BI tracking events for the Damage Protection Landing page
 */
export default {
  onIconClick: () => {
    dio.track(
      'header_damageprotection_click',
      DioType.CLICK,
      {},
      DioContext.DAMAGE_PROTECTION
    );
  },
};
